
export default {
    props: {
        title: {
            type: String,
            default: '',
        },
        src: {
            type: String,
            default: '',
        },
        link: {
            type: String,
            default: '',
        },
        text: {
            type: String,
            default: '',
        },
    },

    computed: {
        image() {
            return this.src ? this.src : require('@/assets/images/placeholder.png')
        },
    },
}
